import { render, staticRenderFns } from "./price-tag.vue?vue&type=template&id=36608b94&scoped=true&lang=html&"
import script from "./price-tag.vue?vue&type=script&lang=js&"
export * from "./price-tag.vue?vue&type=script&lang=js&"
import style0 from "./price-tag.vue?vue&type=style&index=0&id=36608b94&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36608b94",
  null
  
)

export default component.exports